export const getWidgetSentryConfig = (environment: string) => ({
  dsn: 'https://0ad673bcd05c455f9a04042b2c0cc88d@sentry.wixpress.com/307',
  config: {
    environment,
  },
})
